var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.menuComponent,{tag:"component",attrs:{"item":_vm.item,"route-children":_vm.routeChildren}},[(_vm.item.children && _vm.item.children.length>0)?_vm._l((_vm.item.children),function(route){return _c('MenuTreePc',{key:route.code,attrs:{"item":route}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }